'use strict';

/* globals document */

const addStickyBuyPadding = () => {
  const stickyFooter = document.querySelector('#sticky-footer');

  if (!stickyFooter) {
    return;
  }

  const lsFooter = document.querySelector('#ls-lean-footer');
  if (lsFooter) {
    lsFooter.style.height = `${stickyFooter.offsetHeight}px`;
  }
};

module.exports = {
  addStickyBuyPadding,
};
